import { dismissAccountDeleted } from "../services/session.service.js";

/**
 * Shown once, after a successful account deletion.
 *
 * Without it the app simply drops you on the login form, which reads as "it logged me out" rather
 * than as confirmation of something irreversible you just did — and leaves a moment of doubt about
 * whether it actually worked.
 *
 * The copy is warm but does not bargain: no "are you sure?", no win-back offer, no support link
 * dressed up as a second chance. They already confirmed by typing the word; the job here is to
 * acknowledge it and say plainly what happened. It's also honest that the data is gone rather than
 * implying a reversible deactivation — the server's deletion cascades and leaves only a tombstone.
 */
export function AccountDeletedDialog() {
  return (
    <div className="overlay" data-testid="account-deleted-dialog" role="dialog" aria-modal="true">
      <div className="card">
        <h1 className="logo">roo</h1>
        <h2>Sorry to see you go</h2>
        <p className="hint">
          Your account has been deleted, along with your budget and every bank connection. This can't be undone —
          nothing is kept on our side.
        </p>
        <p className="hint">
          Thanks for giving Roo a try. If you ever want to come back, you're welcome to start fresh.
        </p>
        <button type="button" data-testid="account-deleted-close" onClick={dismissAccountDeleted} autoFocus>
          Close
        </button>
      </div>
    </div>
  );
}
